export const resolveTabIndexFromQuery = (tabParam, tabs) => {
  if (tabParam === null || tabParam === undefined) {
    return undefined;
  }

  // Check if it's a numeric value
  const numericIndex = parseInt(tabParam, 10);
  if (!isNaN(numericIndex)) {
    return numericIndex;
  }

  // It's a string ID, find the matching tab's index
  const foundIndex = tabs.findIndex((tab) => tab.id === tabParam);
  if (foundIndex !== -1) {
    return foundIndex;
  }

  return undefined;
};
